import gql from 'graphql-tag';

export default gql`
  query googleAnalyticsData($criteria: GoogleAnalyticsSearchCriteriaInput!) {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        googleAnalytics(criteria: $criteria) {
          flightMarkets {
            flightMarkets {
              itemHaul
              itemMarketType
              itemFocusCity
            }
            errors
          }
        }
      }
    }
  }
`;
